// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
export type SystemStatsFragment = {
  __typename?: "SystemDetails";
  info?: {
    __typename?: "SystemInfo";
    systemType?: string | null;
    data?: {
      __typename?: "SystemInfoData";
      instanceClass?: string | null;
      instanceId?: string | null;
      region?: string | null;
      status?: string | null;
    } | null;
  } | null;
  stats?: {
    __typename?: "SystemStats";
    cpuHardwareModel?: string | null;
    cpuHardwareSockets?: number | null;
    cpuHardwareCoresPerSocket?: number | null;
    cpuHardwareSpeedMhz?: number | null;
    cpuHardwareCacheSize?: number | null;
    schedulerLoadavg1min?: number | null;
    schedulerLoadavg5min?: number | null;
    schedulerLoadavg15min?: number | null;
    memoryTotalBytes?: number | null;
    memoryApplicationBytes?: number | null;
    memoryFreeBytes?: number | null;
    storageBytesTotal?: number | null;
    storageBytesAvailable?: number | null;
  } | null;
};

export const SystemStatsFragmentDoc = gql`
  fragment SystemStats on SystemDetails {
    info {
      systemType
      data {
        instanceClass
        instanceId
        region
        status
      }
    }
    stats {
      cpuHardwareModel
      cpuHardwareSockets
      cpuHardwareCoresPerSocket
      cpuHardwareSpeedMhz
      cpuHardwareCacheSize
      schedulerLoadavg1min
      schedulerLoadavg5min
      schedulerLoadavg15min
      memoryTotalBytes
      memoryApplicationBytes
      memoryFreeBytes
      storageBytesTotal
      storageBytesAvailable
    }
  }
`;
